import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { TOURNEY_HEADER_EMPHASIS_TEXT_COLOR, TOURNEY_HEADER_TEXT_COLOR } from '../../../styles/colors';
const TEXT_CSS = css `
  filter: drop-shadow(1px 1px 0 black);
`;
const TIME_TEXT_CSS = css `
  font-weight: bold;
`;
function calcSecondsRemaining(roundSecondsTotal, startTimestampSeconds) {
    const nowTimestampSeconds = Math.floor(Date.now() / 1000);
    let roundEndTimestamp = startTimestampSeconds + roundSecondsTotal;
    while (roundEndTimestamp < nowTimestampSeconds) {
        roundEndTimestamp += roundSecondsTotal;
    }
    return Math.max(roundEndTimestamp - nowTimestampSeconds, 0);
}
function calcIsExpiring(secondsRemaining) {
    return secondsRemaining <= 10;
}
export const ActiveBlindTimerDisplay = ({ roundSecondsTotal, startTimestampSeconds }) => {
    const [secondsRemaining, setSecondsRemaining] = useState(calcSecondsRemaining(roundSecondsTotal, startTimestampSeconds));
    const [isExpiring, setIsExpiring] = useState(false);
    const updateTimer = useCallback(() => {
        const newSecondsRemaining = calcSecondsRemaining(roundSecondsTotal, startTimestampSeconds);
        const isNowExpiring = calcIsExpiring(newSecondsRemaining);
        if (isExpiring !== isNowExpiring) {
            // expiration state is changing
            setIsExpiring(isNowExpiring);
        }
        setSecondsRemaining(newSecondsRemaining);
    }, [roundSecondsTotal, startTimestampSeconds, isExpiring]);
    useEffect(() => {
        updateTimer(); // update initially
        const interval = setInterval(() => {
            updateTimer();
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [updateTimer]);
    const containerCss = useMemo(() => css `
      color: ${isExpiring ? TOURNEY_HEADER_EMPHASIS_TEXT_COLOR : TOURNEY_HEADER_TEXT_COLOR};
      white-space: nowrap;
      background-color: rgba(0, 0, 0, 0.4);
      padding: 2px 8px 2px 2px;
      border-radius: 0 0 10px 0;
      font-size: 13px;
    `, [isExpiring]);
    const fullMinutesRemaining = Math.floor(secondsRemaining / 60);
    const secondsRemainingThisMinute = secondsRemaining % 60;
    return (_jsx("div", { css: containerCss, children: _jsxs("span", { css: TEXT_CSS, children: ["Blinds", ' ', _jsxs("span", { "aria-label": 'blind timer', css: TIME_TEXT_CSS, children: [fullMinutesRemaining, ":", secondsRemainingThisMinute < 10 ? `0${secondsRemainingThisMinute}` : secondsRemainingThisMinute] })] }) }));
};
